import React from "react"
import PropTypes from "prop-types"
import LinksWithContent from "../LinksWithContent/LinksWithContent"
import TabsContainer from "./TabsContainer"
import * as styles from "./TabsContainer-tw-styles"

const TabsContainerWrapper = props => {
  const { title, linkContent, tabbingWrapperCollection ,variant ,brandTabs} = props
  const style = styles[variant] || styles.defaultStyle

  return (
    <div>
      <div className={style?.tabContainerMainWrapper}>
        <TabsContainer
          title={title}
          tabbingWrapperCollection={tabbingWrapperCollection}
          variant={variant}
          className={style?.tabContainerWrapperTabs}
          brandTabs={brandTabs}
        />
        <LinksWithContent {...linkContent} variant={variant}/>
      </div>
    </div>
  )
}

export default TabsContainerWrapper

TabsContainerWrapper.propTypes = {
  title: PropTypes.string,
  linkContent: PropTypes.object,
  tabbingWrapperCollection: PropTypes.object,
  variant:PropTypes.string,
  brandTabs:PropTypes.bool
}
